module.exports = __webpack_public_path__ + "static/media/logo.8ef0b5b3.svg";